<div class="d-flex justify-content-center">
    <div class="logo py-3">
        <img *ngIf="isDefaultBrand" src="assets/images/new-logo.png"
             class="w-100"
             alt="Ledger Sync">
        <img *ngIf="!isDefaultBrand && logo" [src]="logo"
             class="h-100"
             alt="Ledger Sync">
    </div>
</div>
<router-outlet></router-outlet>
